import { useCallback } from "react";

import { enterHandle, joinSpace } from "../../lib/runtime";

import { SpacePage } from "./SpacePage";

const SIGIL = "@";
const HANDLE = /^[a-z0-9][a-z0-9_]{2,39}$/;

/** One pasted address: an account front door when it is spelled like a handle, a join code else. */
export function AddressPage({ address, as }: { address: string; as?: string }) {
  const sigilled = address.startsWith(SIGIL);
  const bare = sigilled ? address.slice(SIGIL.length) : address;
  const handle = sigilled || HANDLE.test(bare) ? bare : null;
  const resolve = useCallback(
    () => (handle === null ? joinSpace(address) : enterHandle(handle)),
    [address, handle],
  );

  if (handle === "") return <NotHere path={address} />;
  return (
    <SpacePage
      resolveKey={address}
      resolve={resolve}
      label={address}
      kind={handle === null ? "code" : "handle"}
      {...(as === undefined ? {} : { as })}
    />
  );
}

/** The one address that is neither: a bare sigil naming nobody. */
function NotHere({ path }: { path: string }) {
  return (
    <main
      style={{
        position: "fixed",
        inset: 0,
        display: "grid",
        placeItems: "center",
        background: "#0b0d10",
        color: "rgba(255,255,255,0.65)",
        font: "13px ui-monospace, monospace",
      }}
    >
      {`nothing lives at /${path}`}
    </main>
  );
}
